import { IconChevronDown } from '@veneer/core';
import Skeleton from 'react-loading-skeleton';

import styles from './virtual-agent-skeleton.module.scss';

interface VirtualAgentSkeletonProps {
  handleClose?: () => void;
}

export const VirtualAgentSkeleton = (props: VirtualAgentSkeletonProps) => {
  const { handleClose } = props;
  return (
    <div className={styles['container']} id="virtual-agent-skeleton">
      <div className={styles['header']}>
        <p className={styles['title']}>Live Chat </p>
        <IconChevronDown
          className={styles['close']}
          size={30}
          onClick={handleClose}
        />
      </div>
      <Skeleton className={styles['skeleton']} />
    </div>
  );
};
